import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatRadioChange } from '@angular/material/radio';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { map } from 'rxjs/operators';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { ThemeService, Theme } from 'src/app/shared/services/theme.service';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

@Component({
    selector: 'fury-config-panel',
    templateUrl: './config-panel.component.html',
    styleUrls: ['./config-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfigPanelComponent extends BaseComponent implements OnInit {

  public activeTheme$ = this._themeService.activeTheme$;
  public navigation$ = this._themeService.config$.pipe(map(config => config.navigation));
  public sidenavOpen$ = this._sidenavService.open$;
  public sidenavCollapsed$ = this._sidenavService.collapsed$;
  public sidenavUserVisible$ = this._themeService.config$.pipe(map(config => config.sidenavUserVisible));
  public toolbarVisible$ = this._themeService.config$.pipe(map(config => config.toolbarVisible));
  public toolbarPosition$ = this._themeService.config$.pipe(map(config => config.toolbarPosition));
  public footerVisible$ = this._themeService.config$.pipe(map(config => config.footerVisible));
  public footerPosition$ = this._themeService.config$.pipe(map(config => config.footerPosition));

  constructor(
    private _themeService: ThemeService,
    private _sidenavService: SidenavService
  ) {
    super();
  }

  ngOnInit() {
  }

  setActiveTheme(theme: Theme) {
    this._themeService.setTheme(theme);
  }

  navigationChange(change: MatRadioChange) {
    this._themeService.setNavigation(change.value);
  }

  sidenavOpenChange(change: MatSlideToggleChange) {
    change.checked ? this._sidenavService.open() : this._sidenavService.close();
  }

  sidenavCollapsedChange(change: MatCheckboxChange) {
    this._sidenavService.setCollapsed(change.checked);
  }

  sidenavUserChange(change: MatCheckboxChange) {
    this._themeService.setSidenavUserVisible(change.checked);
  }

  toolbarVisibleChange(change: MatSlideToggleChange) {
    this._themeService.setToolbarVisible(change.checked);
  }

  toolbarPositionChange(change: MatRadioChange) {
    this._themeService.setToolbarPosition(change.value);
  }

  footerVisibleChange(change: MatSlideToggleChange) {
    this._themeService.setFooterVisible(change.checked);
  }

  footerPositionChange(change: MatRadioChange) {
    this._themeService.setFooterPosition(change.value);
  }
}
